import * as types from '../constants/ActionTypes';

/**
 * Removes last element from error Queue
 * @returns {Action}
 */
export function dequeueError() {
  return { type: types.DEQUEUE_ERROR };
}

export function queueError(error) {
  return { type: types.QUEUE_ERROR, payload: error };
}



// WEBPACK FOOTER //
// ./actions/errorActions.js